import firebase from 'firebase/app';
import 'firebase/auth';
/**
 * A wrapper class for firebase functionality
 */
class Firebase {
    constructor(config) {
        this.doSignInWithEmailAndPassword = (email, password) => this.auth.signInWithEmailAndPassword(email, password);
        this.doSignInWithSSO = () => {
            const provider = new firebase.auth.GoogleAuthProvider();
            return firebase.auth().signInWithPopup(provider);
        };
        this.doSignInAnonymously = () => this.auth.signInAnonymously();
        this.doSignOut = () => this.auth.signOut();
        this.doSendPasswordResetEmail = (email) => this.auth.sendPasswordResetEmail(email);
        this.doVerifyPasswordResetCode = (code) => this.auth.verifyPasswordResetCode(code);
        this.doConfirmPasswordReset = (code, newPassword) => this.auth.confirmPasswordReset(code, newPassword);
        this.doRefreshToken = () => {
            if (this.auth.currentUser) {
                this.auth.currentUser.getIdToken();
            }
        };
        this.onAuthStateChanged = (cb) => this.auth.onAuthStateChanged(cb);
        this.checkLoggedIn = () => {
            return new Promise((resolve) => {
                this.auth.onAuthStateChanged((user) => {
                    if (user) {
                        resolve(user);
                    }
                    else {
                        resolve();
                    }
                });
            });
        };
        this.doUpdatePassword = (currentPassword, newPassword) => {
            return new Promise((resolve, reject) => {
                const currentUser = this.auth.currentUser;
                if (currentUser === null) {
                    reject();
                    return;
                }
                const credential = firebase.auth.EmailAuthProvider.credential(currentUser.email, currentPassword);
                currentUser
                    .reauthenticateWithCredential(credential)
                    .then(() => {
                    return currentUser.updatePassword(newPassword);
                })
                    .then(() => {
                    resolve();
                })
                    .catch((err) => {
                    reject(err);
                });
            });
        };
        this.doVerifyEmail = (token) => {
            return this.auth.applyActionCode(token);
        };
        firebase.initializeApp(config);
        this.auth = firebase.auth();
    }
}
export default Firebase;
//# sourceMappingURL=firebase.js.map